import Error from '../model/Error';
import axios from 'axios';

export default class KindergartenHintRepository {
    static getCount(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`kindergartens/${kindergartenId}/hints/count`)
                .then((response) => resolve(response.data.data.count))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getNew(kindergartenId, uuids) {
        return new Promise((resolve, reject) => {
            axios
                .get(`kindergartens/${kindergartenId}/hints/new-ones`, { params: uuids?.length ? { uuids } : {} })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getCategories(kindergartenId, section) {
        return new Promise((resolve, reject) => {
            axios
                .get(`kindergartens/${kindergartenId}/hints/categories`, { params: { section } })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getProblems(kindergartenId, section, category, page) {
        return new Promise((resolve, reject) => {
            axios
                .get(`kindergartens/${kindergartenId}/hints`, { params: { section, category, page } })
                .then((response) => resolve({
                    problems: response.data.data,
                    pagination: response.data.meta.pagination,
                }))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static solveProblem(problemId, solution) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`kindergartens/hint/${problemId}/solve`, { solution })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static updateProblem(problemId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`kindergartens/hint/${problemId}/update`, {})
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
